import { render, staticRenderFns } from "./custom-form-label.vue?vue&type=template&id=14523f7c&scoped=true"
import script from "./custom-form-label.vue?vue&type=script&lang=js"
export * from "./custom-form-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14523f7c",
  null
  
)

export default component.exports